export default function tryParseJson(str) {
  try {
    return JSON.parse(str)
  } catch (e) {
    return undefined
  }
}
